<template>
  <div :id="elementId">
    <label class="question-label">{{ question }}</label>
    <vue-dropzone
      ref="questionDropzone"
      :id="elementId + '_drop'"
      :options="dropzoneOptions"
    ></vue-dropzone>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { mapState } from 'vuex';

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    id: Number,
    question: String,
    filename: String,
    type: String,
  },
  // Removed files is triggered on destroying. This handles that issue: https://gitlab.com/meno/dropzone/-/issues/171
  data() {
    return {
      is_destroying: false,
      headers: {
        'Access-Control-Allow-Origin': 'Access-Control-Allow-Methods: GET, POST',
      },
    };
  },
  beforeDestroy() {
    this.is_destroying = true;
  },
  destroyed() {
    this.is_destroying = false;
  },
  computed: {
    ...mapState('print', ['proposalIdOrUid']),
    uploadUrl() {
      return "/NotApplicable";
    },
    dropzoneOptions() {
      return {
        url: this.uploadUrl,
        thumbnailWidth: 150,
        maxFilesize: 10,
        addRemoveLinks: true,
        dictDefaultMessage: "<i class='fa fa-upload'></i> Drop your files here or click to upload a file",
        headers: this.headers,
      };
    },
    uploadedFiles() {
      var files = this.$store.getters['print/uploadedFiles'](this.id);
      return files;
    },
    elementId() {
      return this.type + this.id;
    },
  },
  mounted() {
    this.$nextTick(function () {
      // sometimes got an error could not find dropzone ref so added this so
      // code that will run only after the entire view has been rendered
      this.addFilesFromServer();
    });
  },
  methods: {
    addFilesFromServer() {
      if (this.$debug) console.log('adding server files');
 
      let dzRef = this.$refs.questionDropzone;
      this.uploadedFiles.forEach((uploaded) => {
        let url = "/NotApplicable";
        let file = { name: uploaded.originalFileName, size: uploaded.fileSize };
        dzRef.manuallyAddFile(file, url);
      });
    },
  },
};
</script>
<style scoped>
ul {
  list-style-type: none;
}
</style>
